<template>
  <el-carousel :interval="5500" arrow="always">
    <!-- :key="item" -->
    <el-carousel-item v-for="(item,index) in data" :key="index">
      <!-- <div class="elimg"></div> -->
      <img id="el-carousel_bg" v-if="item.v" @click="gojp(index)" :src="item.picUrl"/>
      <video autoplay="autoplay" controls="controls" controlsList="nodownload"  id="video" loop="loop" muted :src="item.picUrl" v-if="!item.v" >
        您的浏览器不支持 video 标签。
      </video>
      <div class="videobg" @click="gojp(index)"  v-if="!item.v">
        <img v-if="item.black" src="../../assets/imges/ComputerTerminal_rightBG.png" />
      </div>
      <div  class="base_containe" v-if="item.a">
        <div class="text_cont">
            <div class="tx_b"></div>
            <div class="tx_t">
               <div class="t1" v-if="item.t1">
                  <h1>{{item.t1}}</h1>
                </div>
                <div class="t2" v-if="item.t2">
                  <h6>{{item.t2}}</h6>
                </div>
                <div class="t3" v-if="item.txt">
                  <p>{{item.txt}}</p>
                </div>
            </div>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      data: [
            {
              picUrl:"https://oss.3dyunchuang.com/home_pic/video/exposhow.mp4",
              //  0代表视频 1代表图片
              v:0,
              a:1,
              t1:"线上VR云展览会/企业云展厅",
              t2:"VR cloud exhibition / Enterprise Cloud exhibition hall",
              txt:"专业承建各类大型云端VR展览会、VR交易会、VR博览会、企业VR展厅、VR临展摊位",
              black:false
            },
            {
              picUrl:"https://oss.3dyunchuang.com/home_pic/video/night_view.mp4",
              //  0代表视频 1代表图片
              v:0,
              a:1,
              t1:"云创自研-全高清16K实景拍摄场景复刻漫游",
              t2:"Full HD SLR 16K live shooting scene reproduction roaming",
              txt:"独有高清画质、室内外无缝对接技术，广泛适用于各类展览馆、纪念馆、户外景区、园区VR实拍漫游",
              black:false
            },
            {
              picUrl:"https://oss.3dyunchuang.com/home_pic/video/jbookvr.mp4",
              //  0代表视频 1代表图片
              v:0,
              a:1,
              t1:"线上VR云展览会/企业云展厅",
              t2:"VR cloud exhibition / Enterprise Cloud exhibition hall",
              txt:"专业承建各类大型云端VR展览会、VR交易会、VR博览会、企业VR展厅、VR临展摊位",
              black:true
            },
            {
              picUrl:"http://oss.3dyunchuang.com/home_pic/banner/banner3.png",
              //  0代表视频 1代表图片
              v:1,
              a:0,
              t1:"",
              t2:"",
              txt:"",
              black:false
            },       
              {
              picUrl:"https://oss.3dyunchuang.com/home_pic/video/pshow.mp4",
              //  0代表视频 1代表图片
              v:0,
                a:1,
              t1:"线上VR仿生画展/艺术展",
              t2:"Digital VR Art Exhibition",
              txt:"VR画廊场景搭建，画作高清展现，沉浸式逛展体验，定制画廊、学校毕业画展。美丽追忆，永久留存。",
              black:true
            },
            {
              picUrl:"https://oss.3dyunchuang.com/home_pic/video/robot.mp4",
              //  0代表视频 1代表图片
              v:0,
              a:1,
              t1:"整体行业VR展会一站式解决方案/元宇宙企业展厅",
              t2:"Overall industry VR exhibition solution / meta enterprise exhibition hall",
              txt:"专业承建各类大型云端VR展览会、VR交易会、VR博览会、企业VR展厅、VR临展摊位",
              black:false
            },
              {
              picUrl:"http://oss.3dyunchuang.com/home_pic/banner/header_banner4.jpg",
              //  0代表视频 1代表图片
              v:1,
              a:1,
              t1:"VR实景展馆、展品数字复刻",
              t2:"Digital 3D visualization exhibition hall",
              txt:"高清VR实拍建模，数字还原实景展馆、博物馆、党建、艺术展厅，3D扫描+精度建模展品线上展示。足不出户，亲临其境，线上展会永久归档访问。",
              black:false
            },
            {
              picUrl:"https://oss.3dyunchuang.com/home_pic/banner/banner_nav.jpg",
              //  0代表视频 1代表图片
              v:1,
              a:0,
              t1:"线上VR仿生画展/艺术展",
              t2:"Digital VR Art Exhibition",
              txt:"VR画廊场景搭建，画作高清展现，沉浸式逛展体验，定制画廊、学校毕业画展。美丽追忆，永久留存。"
            }
          ]
    }
  },
  methods:{
    gojp(e){
      if(e == 0){
            this.$router.push({
                path: `/cases`,
                query: {
                    //  goid: 'cal'
                }
            })
      }
      if(e == 1 || e == 2 || e == 3){
            this.$router.push({
                path: `/scheme`,
                query: {
                    //  goid: 'cal'
                }
            })
      }
      if(e == 4 || e == 5 || e == 6 || e == 7){
            this.$router.push({
                path: `/cases`,
                query: {
                    //  goid: 'cal'
                }
            })
      }
    }
  }
}
</script>
<style  scoped>
 .elimg{
    z-index: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    background: -webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(transparent));
    background: linear-gradient(90deg,rgba(0,0,0,.5),transparent);
    cursor: pointer;
  }
  .base_containe{
    position: absolute;
    z-index: 2;
    left: 360px;
    top:300px;
    max-width: 1582px;
    color: #fff;
    min-width: 900px;
    height: 239px;
    background: rgba(25,25,25,.5);
   
    }
  .text_cont{
    /* width: 730px; */
    height: 150px;
    margin: 43px 0px 0px 30px;
  }
  .tx_b{
    height: 100%;
    width: 8px;
    height: 145px;
    background: #357eff;
    margin-right: 50px;
    float: left;
  }
  .t1 h1{
    font-size: 34px;
  }
  .t1 {
    margin-bottom: 15px;
    letter-spacing: 2px;
  }
  .t2{
    margin-bottom: 25px;
  }
  .t2 h6{
    font-size: 15px;
    color: #cbc7c5;
    font-size: medium;
        letter-spacing: 1px;
  }
  .t3 P{
    font-size: 16px;
    color: #dad7d5;
    letter-spacing: 1px;
  }
  .base_containe span{
    display: inline-block;
    width: 176px;
    height: 51px;
    background: rgba(35,184,255,.98);
    border-radius: 26px;
    text-align: center;
    line-height: 51px;
    font-size: 20px;
    cursor: pointer;
  }
  .base_containe span:hover{
   background: dodgerblue;
  }
  video::-webkit-media-controls {
    display:none !important;
  }
</style>
<style>

  .el-carousel__container{
    height: 850px!important;
  }
  @media screen and (min-width: 1921px) {
    .el-carousel__container{
      height: 990px!important;
    }
    #video{
      height: 100%!important;
    }
  }
  .el-carousel__indicator.is-active button{
    background: #fff!important;
    box-shadow: 0px 0px 1px #888888;
  }
  .el-carousel__button{
    background-color: #cbc7c5!important;
  }
  .el-carousel__container img{
    width: 100%;
    height: 100%;
  }
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  .el-carousel__button{
    width: 50px;
    height: 3px;
  }
  .el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 14px 12px;
}
  button.el-carousel__arrow.el-carousel__arrow--left{
    font-size: 36px;
    height: 74px;
    width: 74px;
    background: rgba(25,25,25,.5);
    border-radius: 0!important;
    left: 70px;
  } 
  button.el-carousel__arrow.el-carousel__arrow--right {
    font-size: 36px;
    height: 74px;
    width: 74px;
    background: rgba(25,25,25,.5);
    border-radius: 0!important;
    right: 70px;
 }

  #video{
    width: 100%;
    height: 925px;
      object-fit: fill;
    /* width: 1920 * 850; */
    /* height: 849px; */
    text-align: center;
  }
  .videobg{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    /* opacity: 0.8; */
  }
   .videobg img{
     width: 100%;
     opacity: 0.7;
     height: 100%;
   }
 

</style>


// WEBPACK FOOTER //
// src/common/index/page-header.vue